import React from 'react';

import {useOnFocusOutside} from './useOnFocusOutside';

type OwnProps<C extends React.ElementType> = {
    as?: C;
    enable?: boolean;
    onFocusOutside: () => void;
};

type OutsideFocusHandlerContainerProps<C extends React.ElementType> = OwnProps<C> &
    Omit<React.ComponentPropsWithoutRef<C>, keyof OwnProps<C>>;

export function OutsideFocusHandlerContainer<C extends React.ElementType = 'span'>({
    as,
    enable,
    onFocusOutside,
    onFocus,
    ...props
}: OutsideFocusHandlerContainerProps<C>) {
    const handleFocus = useOnFocusOutside(onFocusOutside, enable);
    const Component = as || 'span';
    return (
        <Component
            {...props}
            onFocus={(e) => {
                handleFocus();
                if (typeof onFocus === 'function') {
                    onFocus(e);
                }
            }}
        />
    );
}
